import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const bulkGetMissingRequiredDraftAmends = api(async function bulkGetMissingRequiredDraftAmends({
    projectId,
    scheduleIds,
}) {
    if (!projectId || !scheduleIds?.length) return []
    return query(
        gql`
            query BulkGetMissingRequiredDraftAmends($projectId: String!, $scheduleIds: [String!]!) {
                bulkGetMissingRequiredDraftAmends(projectId: $projectId, scheduleIds: $scheduleIds) {
                    scheduleId
                    title
                    missingAmendsKeys
                    status
                    eligible
                    reason
                }
            }
        `,
        { projectId, scheduleIds },
        { returns: "bulkGetMissingRequiredDraftAmends", fetchPolicy: "network-only" }
    )
})
